import { getBannerCrop } from 'utils/banner/utils';
import { Banner, Campaign, CampaignFields } from 'utils/campaign/requirementUtils/types';
import { getFileName, replaceDirectOnYandexDirect } from 'utils/clickme';
import { BANNER_IMAGE_CROP_TYPES_CONFIG, CROP_CONTAINER_SIZE, ImageComponent } from 'utils/constants/banner';

import { Action } from 'store/createReducer';
import { resetAiImageGeneration } from 'store/models/aiImageGeneration';
import { resetBannerTextGeneration } from 'store/models/bannerTextGeneration';
import {
    resetBannerInfo,
    resetBannerVideo,
    setBannerId,
    setBannerImageByType,
    setBannerImageCropInfoByType,
    setBannerLink,
    setBannerSavedImageByType,
    setBannerSmallImageAllowed,
    setBannerText,
    setBannerTitle,
    setBannerVacancyId,
    setBannerVideo,
    setCampaignIdForBanner,
    setClassificationCodeId,
    setIsAdvertisement,
    setVacancyName,
} from 'store/models/createBanner';
import { setCampaignSubSource } from 'store/models/createCampaign';
import { resetSelectedVideo, setSelectedVideoUploadId } from 'store/models/videoGallery';

type GetBannerCreateBatchActions = (props: { campaign: Campaign; campaignIdForBanner: string }) => Action[];

export const getBannerCreateBatchActions: GetBannerCreateBatchActions = ({ campaign, campaignIdForBanner }) => {
    const newApiSources = replaceDirectOnYandexDirect(campaign.apiSources);
    const url = campaign[CampaignFields.Banner].url;
    const classificationCodeId = campaign[CampaignFields.Banner].classificationCodeId;
    return [
        resetBannerInfo(null),
        setCampaignIdForBanner(campaignIdForBanner),
        setBannerVacancyId(campaign[CampaignFields.VacancyId]),
        setBannerSmallImageAllowed(campaign[CampaignFields.SmallImgAllowed]),
        setCampaignSubSource(newApiSources),
        setBannerLink(url),
        setClassificationCodeId(classificationCodeId),
        resetAiImageGeneration(null),
        resetBannerTextGeneration(),
        ...(campaign[CampaignFields.Banner].isAdvertisement ? [setIsAdvertisement(true)] : []),
        setVacancyName(campaign[CampaignFields.CampaignTitle]),
        resetSelectedVideo(null),
        resetBannerVideo(null),
    ];
};

type GetBannerEditBatchActions = (props: { banner: Banner }) => Action[];

export const getBannerEditBatchActions: GetBannerEditBatchActions = ({ banner }) => {
    const { id, title, text, url, bannerImages, bannerVideo } = banner;
    const actions: Action[] = [
        setBannerId(id),
        setBannerTitle(title),
        setBannerText(text),
        setBannerLink(url),
        setBannerVideo(bannerVideo ?? null),
        setSelectedVideoUploadId(bannerVideo?.videoUploadId ?? null),
    ];

    bannerImages.forEach(
        ({
            originalImageId,
            originalImageUrl,
            imageCropType,
            width,
            height,
            cropStartX,
            cropStartY,
            cropWidth,
            cropHeight,
        }) => {
            const { aspect } = BANNER_IMAGE_CROP_TYPES_CONFIG[imageCropType];

            const cropInfo = getBannerCrop({
                cropContainerSize: CROP_CONTAINER_SIZE,
                imageWidth: width,
                imageHeight: height,
                cropAspect: aspect,
                cropStartX,
                cropStartY,
                originalCropWidth: cropWidth,
                originalCropHeight: cropHeight,
            });

            const image = {
                cropType: imageCropType,
                imageInfo: {
                    id: originalImageId,
                    url: originalImageUrl,
                    width,
                    height,
                    fileName: getFileName(originalImageId, originalImageUrl),
                    cropType: imageCropType,
                    cropInfo,
                    component: ImageComponent.Crop,
                    isLoadedInCrop: false,
                },
            };
            actions.push(
                setBannerImageByType(image),
                setBannerSavedImageByType(image),
                setBannerImageCropInfoByType({ cropType: imageCropType, cropInfo })
            );
        }
    );

    return actions;
};
